import styles from './style.postcss';
import RadialProgress from 'react-radial-progress';
import React, { Component } from 'react';
import classnames from 'classnames';
import { PageCard } from 'omni-common-ui';
import PropTypes from 'prop-types';

class TaskProgressCard extends Component {

  _renderProgressBar(counts) {
    const statsusColor = {
      Completed: '#74d17f',
      Pending: '#f7932d',
      Overdue: '#de4c4c',
      Expired: '#4a4a4a',
    };

    const responsiveParameters = [{
      className: classnames(styles.TaskProgressCard_radialContainer, styles.__md),
      radius: 60,
      circleStrokeWidth: 3,
      edgeSize: 130,
      forcedTextY: 44,
      fontSize: ['24', '', ''],
      fontWeight: 'inherit',
      tspanX: '65',
      tspanDy: ['10', '28', '16'],
      showText: true,
    }, {
      className: classnames(styles.TaskProgressCard_radialContainer, styles.__sm),
      radius: 40,
      circleStrokeWidth: 2,
      edgeSize: 90,
      forcedTextY: 34,
      fontSize: ['18', '11', '11'],
      fontWeight: 'inherit',
      tspanX: '45',
      tspanDy: ['3', '18', '14'],
      showText: true,
    }, {
      className: classnames(styles.TaskProgressCard_radialContainer, styles.__xs),
      radius: 25,
      circleStrokeWidth: 2,
      edgeSize: 60,
      forcedTextY: 32,
      fontSize: ['14', '11', '11'],
      fontWeight: 500,
      tspanX: '30',
      tspanDy: ['3', '18', '14'],
      showText: false,
    }];

    return responsiveParameters
      .map((parameter) => <div className={parameter.className}>
        {
          counts.map((statisticCount) => <div className={styles.TaskProgressCard_svgContainer}>
            <RadialProgress radius={parameter.radius}
                circleStrokeWidth={parameter.circleStrokeWidth}
                edgeSize={parameter.edgeSize}
                forcedTextY={parameter.forcedTextY}
                unit="percent"
                formatText={() => <tspan>
                  <tspan x={parameter.tspanX}
                      dy={parameter.tspanDy[0]}
                      fontSize={parameter.fontSize[0]}
                      fontWeight={parameter.fontWeight}>
                    {statisticCount.count}
                  </tspan>
                  <tspan x={parameter.tspanX}
                      dy={parameter.tspanDy[1]}
                      fontSize={parameter.fontSize[1]}>
                    {parameter.showText && statisticCount.status}
                  </tspan>
                  <tspan x={parameter.tspanX}
                      dy={parameter.tspanDy[2]}
                      fontSize={parameter.fontSize[2]}>
                    {parameter.showText && 'Tasks'}
                  </tspan>
                </tspan>
                }
                circleStroke="#cdcdcd"
                progressStroke={statsusColor[statisticCount.status]}
                value={statisticCount.percentage} />
          </div>)
        }
      </div>);
  }

  _isTasksEmpty(taskCounts) {
    let result = true;
    taskCounts.map((statisticCount) => {
      if (statisticCount.count !== 0) {
        result = false;
      }
      return false;
    });
    return result;
  }

  render() {
    const sinceTimeText = this._isTasksEmpty(this.props.tasksCounts) ?
        '' :
        `since ${this.props.sinceTime}`;
    return <PageCard className={classnames(styles.TaskProgressCard, this.props.className)}>
      <PageCard.Heading className={classnames(this.props.cardTitleClass,
            styles.TaskProgressCard_title)}
          text={this.props.cardTitle}
          stackMode="horizontal">
        <span className={styles.TaskProgressCard_title_time}>{ sinceTimeText }</span>

      </PageCard.Heading>
      <PageCard.Content className={styles.TaskProgressCard_pageCardContent}>
        {this._renderProgressBar(this.props.tasksCounts)}
      </PageCard.Content>
    </PageCard>;
  }
}

TaskProgressCard.propTypes = {
  cardTitleClass: PropTypes.object,
  cardTitle: PropTypes.string,
  tasksCounts: PropTypes.array,
  sinceTime: PropTypes.string,
  showSinceTime: PropTypes.bool,
  className: PropTypes.string,
};

export default TaskProgressCard;



// WEBPACK FOOTER //
// ./components/TaskProgressCard/index.jsx